import React, { Component } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize.min.js'
import { Link } from 'react-router-dom';
import Modal from '../../helper/modal';
import {setMarket} from '../../../actions/ui/marketplace';
import {collateralizeFilterDispatch} from '../../../actions/orderbook/filter';
import Help from "../../helper/help";
import TableHeader from '../../helper/tableHeader';
import {withRouter} from 'react-router-dom';
import {pairs} from '../../../config';
import './marketPicker.css';
import $ from 'jquery';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip'

class MarketPicker extends Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(){
    super()
    this.state = {filter:'',type:'auction',subtype:'all'}
  }
  componentDidMount(){
    let type = this.props.location.hash ? this.props.location.hash.substring(1) : null;
    let search = this.props.location.search;
    if(search && search.length > 1 && search.includes('/')){
      let [asset,denomination] = search.split('/').map((o)=>o.toLowerCase());
      if(denomination !== 'emb') this.props.setMarket({asset:asset.substring(1),denomination,type:type})
    }
    let {pairs} = require('../../../config')
    if(type && Object.keys(pairs).includes(type)){
      this.setState({type})
    }
    else if(type && type == 'auction'){
      this.setState({type,subtype:''})
    }
  }
  async setUrl({denomination,asset}){
    let _this = this;
    if(denomination === 'EMB' || asset === 'EMB'){
      M.toast({html: `EMB Trading has not been activated.`,classes:"black",displayLength:1000});
    }
    else if(asset === 'L-EMB' || asset === 'Existing Leases'){
      M.toast({html: `Lease Trading has not been activated.`,classes:"black",displayLength:1000});
    }
    else if(asset === '111'){
      M.toast({html: `Real Esate Trading has not been activated.`,classes:"black",displayLength:1000});
    }
    else {

      if($('#price')[0]) $('#price')[0].value = '';
      if($('#amount')[0]) $('#amount')[0].value = '';

      this.props.history.push({search:`${asset}/${denomination}`,hash:this.state.type})
      _this.props.setMarket({asset,denomination,type:this.state.type})
      _this.setState({asset,denomination})
      setTimeout(async ()=>{
        await this.props.collateralizeFilterDispatch()
      },200)
    }
  }
  filterPairs(pairs){
    if(this.state.type === 'bid/ask'){
      if(this.state.subtype === 'emb' || this.state.subtype === 'btc'){
        Object.keys(pairs[this.state.type]).filter(key => {
          if(!key.includes(`/${this.state.subtype.toUpperCase()}`)){
            delete pairs[this.state.type][key]
          }
        })
      }
      if(this.state.subtype === 'stable'){
        Object.keys(pairs[this.state.type]).filter(key => {
          if(!(key.includes(`/USDT`) || key.includes(`/DAI`))){
            delete pairs[this.state.type][key]
          }
        })
      }
    }


    if(this.state.filter.length > 0){
      let needle
      if (this.state.filter.includes('/')) {
        needle = this.state.filter.toLowerCase().split('/', 2)
      } else {
        needle = this.state.filter.toLowerCase()
      }
      Object.keys(pairs[this.state.type]).filter(key => {
        let p = pairs[this.state.type][key];

        if (Array.isArray(needle)) {
          const [d, a] = needle
          if(!(p['asset'].toLowerCase().includes(d) && p['denomination'].toLowerCase().includes(a))){
            delete pairs[this.state.type][key]
          }
        } else {
          if(p['denomination'].toLowerCase().includes(needle) || p['asset'].toLowerCase().includes(needle)){

          }
          else {
            delete pairs[this.state.type][key]
          }
        }
      })
    }
  }
  renderItems(pairs){
    return Object.keys(pairs[this.state.type]).map((key,i)=>{
      let p = pairs[this.state.type][key]
      let opacity = this.props.text === key ? '1' : '0.5'
      return (
        <tr key={i} id={key} key={key} style={{opacity,cursor:'pointer'}} onClick={this.setUrl.bind(this,p)} >
          <td style={{paddingTop:i == 0 ? '2px':'0px'}} className='marketItem' >{key.replace('NRG','OL')}</td>
          <td style={{paddingTop:i == 0 ? '2px':'0px'}} className='marketItem' >{p.lastPrice.price != 0 ? p.lastPrice.price.toString().substring(0,10) : '-'}</td>
          <td style={{paddingTop:i == 0 ? '2px':'0px'}} className='marketItem' >{p.volume != 0 ? p.volume.toString().substring(0,10) : '-'}</td>
        </tr>
      )
    })
  }
  renderSearch(){
    return (
      <div className='col s6' style={{padding:0}}>
        <div style={{margin:'5px',border:'1px solid grey',height:'25.5px',background:'#1d1d1d'}}>
        <i className='material-icons searchIcon' style={{marginTop:'6px',marginLeft:'3px'}}>search</i>
        <input id='searchMarkets' type='text' onChange={this.handleChange.bind(this)} />
        </div>
      </div>
    )
  }
  renderBidAsk(){
    let subTitles = [
      'ALL',
      'EMB',
      'BTC',
      'STABLE'
    ]
    let titles = subTitles.map((title,i) => {
      let border = this.state.subtype == title.toLowerCase() ? '1px solid white' : '1px solid grey';
      return (
        <div key={i} className='col s6 chooseFilter' >
          <div style={{border,marginTop:'10px'}}>
          <p onClick={this.setSubType.bind(this,title.toLowerCase())} style={{padding:'2px',fontSize:'8px',cursor:'pointer'}}>
            {title}
          </p>
          </div>
        </div>
      )
    })
    return (
      <div className={`col s3 center`} style={{height:'25.5px',padding:0,color:'white'}}>
        <div style={{margin:'5px',border: this.state.type == 'bid/ask' ? '1px solid white' : '1px solid grey' ,height:'25.5px',background:'#1d1d1d'}}
          ref={(c) => { this.ref = c; }}
          data-tip={`hello`} data-for={'bid_ask_tooltip'}
          onMouseOver={() => { ReactTooltip.show(this.ref); }}
          onMouseLeave={() => { ReactTooltip.hide(this.ref); }}
        >
          <h6 className='marketType' onClick={this.setType.bind(this,'bid/ask')}>Bid/Ask</h6>
        </div>
        <ReactTooltip id={'bid_ask_tooltip'} place="bottom" type="dark" effect="solid" className='extraClass' delayHide={100}>
          <p>Filter By: </p>
          <hr/>
          <div className='col s12'>
          {titles}
          </div>
        </ReactTooltip>
      </div>
    )
  }
  renderAuction(){
    return (
      <div className={`col s3 center`} style={{height:'25.5px',padding:0,color:'white'}}>
        <div style={{margin:'5px',border: this.state.type == 'auction' ? '1px solid white' : '1px solid grey' ,height:'25.5px',background:'#1d1d1d'}}>
        <h6 className='marketType' onClick={this.setType.bind(this,'auction')}>Auction</h6>
        </div>
      </div>
    )
  }
  renderLeases(){
    return (
      <div className={`col s3 center`} style={{height:'25.5px',padding:0,color:'white'}}>
        <div style={{margin:'5px',border: this.state.type == 'leases' ? '1px solid white' : '1px solid grey' ,height:'25.5px',background:'#1d1d1d'}}>
        <h6 className='marketType' onClick={this.setType.bind(this,'leases')}>Leases</h6>
        </div>
      </div>
    )
  }
  renderRealEstate(){
    return (
      <div className={`col s3 center`} style={{height:'25.5px',padding:0,color:'white'}}>
        <div style={{margin:'5px',border: this.state.type == 'realestate' ? '1px solid white' : '1px solid grey' ,height:'25.5px',background:'#1d1d1d'}}>
        <h6 className='marketType' onClick={this.setType.bind(this,'realestate')}>Estate</h6>
        </div>
      </div>
    )
  }
  render(){
    let pairs = JSON.parse(JSON.stringify(this.props.pairs))
    this.filterPairs(pairs)

    return (
      <div>
        <div className="col s12" style={{margin:0,color:'white'}}>
          <div className='col s6' style={{padding:0}}>
            <h6>Market Picker</h6>
          </div>
          {this.renderSearch()}

        </div>
        <div className='col s12 section'>

          <div className='col s12'>
            <div className='col s12' style={{padding:0}}>
              {this.renderAuction()}
              {this.renderBidAsk()}
              {this.renderLeases()}
              {this.renderRealEstate()}
            </div>
          </div>
          <div className='col s12' style={{marginTop:'5px'}}>
          <TableHeader items={['Pair','Price','Volume']} fontSize={'11px'}/>
          <div className='col s12 marketPicker' style={{height:'358px',borderTop:'1px solid grey'}}>
            <table className="white-text order-book marketTable">
              <tbody>
                {this.renderItems(pairs)}
              </tbody>
            </table>
          </div>
          </div>
        </div>
      </div>
    )
  }
  setType(type){
    if(type == 'bid/ask') this.setState({type,subtype:'all'})
    if(type == 'auction') this.setState({type,subtype:''})
    if(type == 'leases') {
      this.setState({type,subtype:''})
      // M.toast({html: `Lease Trading has not been activated.`,classes:"black",displayLength:1000});
    }
    if(type == 'realestate') {
      this.setState({type,subtype:''})
      // M.toast({html: `Real Estate Trading has not been activated.`,classes:"black",displayLength:1000});
    }
  }
  setSubType(subtype){
    this.setState({type:'bid/ask',subtype})
  }
  handleChange(event){
    this.setState({filter:event.target.value})
  }
}

function mapStateToProps(state,props) {
  return {
    pairs2: state.orderbook.pairs,
    pairs: state.orderbook.stats,
    text:`${state.ui_marketplace.market.asset}/${state.ui_marketplace.market.denomination}`
  };
}

export default connect(mapStateToProps, {setMarket,
  collateralizeFilterDispatch
})(withRouter(props => <MarketPicker {...props}/>));
